export const zipRegexes = {
  'notino.cz': {
    pattern: /\d{3} \d{2}$/,
    mask: '999 99',
  },
  'notino.sk': {
    pattern: /\d{3} \d{2}$/,
    mask: '999 99',
  },
  'notino.pl': {
    pattern: /\d{2}-\d{3}$/,
    mask: '99-999',
  },
  'notino.de': {
    pattern: /^\d{5}$/,
    mask: '99999',
  },
  'notino.at': {
    pattern: /^\d{4}$/,
    mask: '9999',
  },
  'notino.hu': {
    pattern: /^\d{4}$/,
    mask: '9999',
  },
  'notino.es': {
    pattern: /^\d{5}$/,
    mask: '99999',
  },
  'notino.pt': {
    pattern: /^\d{4}$/,
    mask: '9999',
  },
  'notino.co.uk': {
    pattern:
      /^(([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/,
    // as UK post code is too complex we do not provide mask
    mask: null,
  },
  'notino.fr': {
    pattern: /^\d{5}$/,
    mask: '99999',
  },
  'notino.it': {
    pattern: /^\d{5}$/,
    mask: '99999',
  },
  'notino.nl': {
    pattern: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z|A-Z]{2}$/i,
    mask: '9999 aa',
  },
  'notino.be': {
    pattern: /^\d{4}$/,
    mask: '9999',
  },
  'notino.hr': {
    pattern: /^\d{5}$/,
    mask: '99999',
  },
  'notino.si': {
    pattern: /^(\d{4})$/,
    mask: '9999',
  },
  'notino.dk': {
    pattern: /^\d{4}$/,
    mask: '9999',
  },
  'notino.fi': {
    pattern: /^\d{5}$/,
    mask: '99999',
  },
  'notino.gr': {
    pattern: /\d{3} \d{2}$/,
    mask: '999 99',
  },
  'notino.bg': {
    pattern: /^\d{4}$/,
    mask: '9999',
  },
  'notino.ua': {
    pattern: /^\d{5}$/,
    mask: '99999',
  },
  'notino.se': {
    pattern: /\d{3} \d{2}$/,
    mask: '999 99',
  },
  'notino.ro': {
    pattern: /^\d{6}$/,
    mask: '999999',
  },
  'notino.ch': {
    pattern: /^\d{4}$/,
    mask: '9999',
  },
  'notino.ru': {
    pattern: /^\d{6}$/,
    mask: '999999',
  },
};
export const WISHLIST_BASE_URL = '/wishlist';
export const LOGIN_URL = (returnUrl: string) =>
  `/login?returnUrl=${encodeURIComponent(returnUrl)}`;
